import { ready } from "../shared/utils"

const hamburgerListener = () => {
  const hbgBtn = document.querySelector<HTMLElement>('.hamburger__button')
  const hbgDrop = document.querySelector<HTMLElement>('.hamburger__drop')
  const hbgDom = document.querySelector<HTMLElement>('#hamburger')
  const toggleClass = () => {
    hbgDom.classList.toggle('show')
    hbgBtn.classList.toggle('open')
  }
  if (hbgBtn && hbgDom) {
    hbgBtn.addEventListener('click', toggleClass)
    hbgDrop.addEventListener('click', toggleClass)
  }
}

ready(() => {
  hamburgerListener()
})
